
@if (showLocalFilter) {
  <mat-form-field class="search-input">
    <input placeholder="Filter"
      matInput
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="applyFilter($event)">
      <mat-chip-grid #chipList>
      </mat-chip-grid>
    </mat-form-field>
  }
  @for (item of searchItems; track item) {
    <mat-chip-option [selectable]="selectable"
      [removable]="removable" (removed)="remove(item)">
      {{item.name}}
      @if (removable) {
        <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-option>
  }
  <div class="example-container">
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      class="mat-elevation-z8 mat-table-custom" id="ContactToUnitlist">
      @for (item of columnsToDisplay; track item) {
        <ng-container matColumnDef="{{item}}">
          <th mat-header-cell *matHeaderCellDef>
            {{item === 'status' || item === 'index' || item === 'arrow-items' ? '' : item}}
          </th>
          @if (item === 'index') {
            <ng-container matColumnDef="index-table">
              <td mat-cell *matCellDef="let element; let i = dataIndex">
                <p>{{i+1}}</p>
              </td>
            </ng-container>
          }
          @if (item==='actions') {
            <td mat-cell *matCellDef="let element">
              @if (!isEditingRow(element,item)) {
                <button mat-icon-button matTooltip="Edit Row"
                  (click)="onRowEditInit(element)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (!isEditingRow(element,item)) {
                <button mat-icon-button matTooltip="Check History"
                  (click)="openChangeHistoryDialog(element)">
                  <mat-icon>history_toggle_off</mat-icon>
                </button>
              }
              @if (isEditingRow(element,item)) {
                <button mat-icon-button matTooltip="Cancel Row"
                  (click)="onRowEditCancel(element)">
                  <mat-icon>rotate_left</mat-icon>
                </button>
              }
            </td>
          }
          @if (item!=='actions') {
            <ng-container *matCellDef="let element" >
              @switch (getDataType(item)) {
                @case ('boolean') {
                  <td mat-cell [ngClass]="isEditingRow(element,item) ? 'editedbg' :''">
                    <mat-checkbox (change)="changeElement(element, item, $event.checked)" [checked]="getInput(element,item)" [ngClass]="isEditingRow(element,item) ? 'black' :''" [disabled]="!isEditingRow(element,item)"></mat-checkbox>
                  </td>
                }
                @case ('string') {
                  <td mat-cell>
                    <p [innerHTML]="getInput(element,item)"></p>
                  </td>
                }
                @case ('number') {
                  <td mat-cell>
                    <p [innerHTML]="getInput(element,item)"></p>
                  </td>
                }
                @case ('date') {
                  <td mat-cell class="datepicker">
                    <p [innerHTML]="getInput(element,item) | date:'yyyy-MM-dd HH:mm'"></p>
                  </td>
                }
              }
            </ng-container>
          }
        </ng-container>
      }


      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
        class="item">
      </table>
    </div>

